import axios from "axios";
import { Fragment, useEffect, useState } from "react"
import "./Home.css";
import "./card.css"

import Metadata from "./Metadata";
import { useDispatch, useSelector } from "react-redux";

import Loader from "./Loader";
import Productslice from "../store/Productslice";
import Productdetail from "./Product";
import { useParams } from "react-router-dom";
import Homehmadeslice from "../store/Homemadeslice";



const Homeproduct = () => {
    console.log("success")
    const dispatch = useDispatch();
    const homeproductvalue = useSelector((store) => {
        return store.product.product

    })

    console.log(homeproductvalue)
    const loader = useSelector((store) => {
        return store.product.loading

    })
    const { id } = useParams();


    useEffect(() => {
        dispatch(Productslice.actions.productrequest())
        axios.get(`https://retoolapi.dev/BUQ2aS/allcomponents/?num=${id}`)
            .then(response => dispatch(Productslice.actions.productsuccess(response.data)))
            .catch(err => console.log(err))


    }, []);


    return (
        <Fragment>

            {loader ? <Loader> </Loader> :
                <div className="frames">
                    {/* <Metadata title={homeproductvalue[0].title}> </Metadata> */}
                    {homeproductvalue.map((ele, idx) => {
                        console.log(homeproductvalue[0].title)
                        console.log(ele.title)
                        return (
                            <Productdetail id={ele.id} img={ele.img} num={ele.num} title={ele.title} desc={ele.desc} price={ele.price} stock={ele.stock} ></Productdetail>
                        )
                    })}


                </div>}



        </Fragment>

    )


}
export default Homeproduct;